import { asyncComponent } from 'react-async-component';

const RoomSceneReviewLayout = asyncComponent<{}>({
  resolve: () => import('./Layout').then(x => x.default)
});

export default RoomSceneReviewLayout;
